/**
 * @Description: 耗材的扩展属性定义（属性名称）信息相关接口
 */
import { ContentType, Method } from 'axios-mapper'
import https from '@/utils/https'
import { RootObject } from '@/model/rootObject'
import { PageRespModel } from '@/model/pageRespModel'
import { Route } from '@/constant/route'
import {
  MaterialAttributeDefModel,
  MaterialAttributeDefSearchModel,
  MaterialAttributeDefPageSearchModel,
  MaterialAttributeDefAddModel,
  MaterialAttributeDefUpdateModel,
  IdsModel
} from '@/model/product/MaterialAttributeDefModel'

const baseUrl = Route.product + '/materialAttributeDef'

/**
 * 搜索分页数据
 */
export const pageSearchMaterialAttributeDef = (param: MaterialAttributeDefPageSearchModel) => {
  return https().request<RootObject<PageRespModel<MaterialAttributeDefModel>>>(baseUrl.concat('/list'), Method.POST, param, ContentType.json)
}

/**
 * 搜索所有数据
 */
export const searchMaterialAttributeDef = (param: MaterialAttributeDefSearchModel) => {
  return https().request<RootObject<MaterialAttributeDefModel[]>>(baseUrl.concat('/list/all'), Method.POST, param, ContentType.json)
}

/**
 * 根据ID查找数据
 */
export const getMaterialAttributeDef = (id: number) => {
  return https().request<RootObject<MaterialAttributeDefModel>>(baseUrl.concat('/get/').concat(id.toString()), Method.GET, undefined, ContentType.json)
}

/**
 * 添加数据
 */
export const addMaterialAttributeDef = (param: MaterialAttributeDefAddModel) => {
  return https().request<RootObject<any>>(baseUrl.concat('/add'), Method.POST, param, ContentType.json)
}

/**
 * 更新数据
 */
export const updateMaterialAttributeDef = (param: MaterialAttributeDefUpdateModel) => {
  return https().request<RootObject<any>>(baseUrl.concat('/update'), Method.POST, param, ContentType.json)
}

/**
 * 删除数据
 */
export const removeMaterialAttributeDef = (id: number) => {
  return https().request<RootObject<any>>(baseUrl.concat('/remove/').concat(id.toString()), Method.POST, undefined, ContentType.json)
}

/**
 * 批量删除数据
 */
export const batchRemoveMaterialAttributeDef = (param: IdsModel) => {
  return https().request<RootObject<any>>(baseUrl.concat('/batch/remove'), Method.POST, param, ContentType.json)
}
